/*---------------------------------------------------------*\
 * Imports
 \*---------------------------------------------------------*/
import angular from 'angular';

/*---------------------------------------------------------*\
 * regionService
 \*---------------------------------------------------------*/
/* @ngInject */
function adService(apiService, config) {
  this.getAd = (section, adLocation, regionCode) => {
    if (!angular.isString(regionCode) || regionCode.length !== 2) {
      throw new Error('A two-character region code is required');
    }
    if (!angular.isString(section)) {
      throw new Error('A section is required. i.e. home, photos');
    }
    if (!angular.isString(adLocation)) {
      throw new Error('adLocation is required. i.e. footer_center');
    }
    return apiService.wrap(`${config.relBaseUrlAPi}/ads/${section}/${adLocation}/${regionCode}`,
      {}, 'ads', true)
      .then((res) => {
        if (!res.data) {
          return {};
        }
        return res.data;
      });
  };
}

adService.$inject = [
  'apiService',
  'config'
];

const api = angular
    .module('adService', ['config', 'apiService'])
    .service('adService', adService);

export default api;



/** WEBPACK FOOTER **
 ** ./client/app/services/apis/ads.js
 **/